import React from 'react';
import noop from 'no-op';
import PropTypes from 'prop-types';
import BaseComponent from 'components/BaseComponent';

export default function withStateLink(ComposedComponent) {
  return class StateLink extends BaseComponent {
    static propTypes = {
      onChange: PropTypes.func,
      stateLink: PropTypes.array.isRequired,
    };

    static defaultProps = {
      onChange: noop,
    };

    handleChange = (value) => {
      const [context, stateField] = this.props.stateLink;
      context.setState({
        [stateField]: value,
      }, () => {
        this.props.onChange(value);
      });
    };

    render() {
      return (
        <ComposedComponent
          { ...this.props }
          onChange={ this.handleChange }
        />
      );
    }
  };
}
